import { AuthOptions } from '../models/auth-options.model';
import { EnAuthOptionsOperator } from '../enums/auth-options-operator.enum';

export class DataAuthFactory {
  static create(id: string | string[], operator: EnAuthOptionsOperator = EnAuthOptionsOperator.AND): AuthOptions {
    return new AuthOptions(id, operator);
  }

  static createExact(id: string | string[], operator: EnAuthOptionsOperator = EnAuthOptionsOperator.AND): AuthOptions {
    return new AuthOptions(id, operator, true);
  }
}
